import React from 'react';
import { Box, Button, MenuItem, TextField, Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const SplitBillingPatientPaymentBox = ({
  amount,
  currency,
  paymentMethod,
  onPaymentMethodChange,
  onSubmit,
  disabled = false,
  paymentOptions = [],
  buttonLabel = 'Collect patient share now',
  classes = {},
  bookingDialogMenuProps = undefined,
}) => {
  if (!(Number(amount) > 0)) {
    return null;
  }

  return (
    <Box style={{ marginTop: 12, padding: '10px 12px', borderRadius: 8, backgroundColor: '#f5f9ff', border: '1px solid #dce8f5' }}>
      <Typography variant="body2" style={{ color: '#002D55', fontWeight: 700, lineHeight: 1.4 }}>
        Patient share due now: {currency} {Number(amount).toFixed(2)}
      </Typography>
      <Typography variant="caption" style={{ color: '#6f7c8d', display: 'block', marginTop: 2 }}>
        Collect the patient share immediately with MobilePay, card, transfer, or cash. The insurance share can still be sent separately.
      </Typography>
      <TextField
        select
        label="Patient payment method"
        name="split_payment_method"
        value={paymentMethod}
        onChange={onPaymentMethodChange}
        fullWidth
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        className={`${classes.orangeFocused || ''} ${classes.textfieldColor || ''}`.trim()}
        style={{ marginTop: 10 }}
        SelectProps={{ MenuProps: bookingDialogMenuProps }}
      >
        {paymentOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <Button
        fullWidth
        variant="contained"
        onClick={onSubmit}
        disabled={disabled || !paymentMethod}
        className={classes.PayButton}
        style={{ marginTop: 10 }}
        startIcon={<CheckCircleIcon style={{ color: '#fff' }} />}
      >
        {buttonLabel}
      </Button>
    </Box>
  );
};

export default SplitBillingPatientPaymentBox;